import React, { Component, createElement, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Spacer from 'atoms/Spacer'

const styles = theme => ({
  root: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 38 * 0.65,
    background: 'none',
    border: 0,
    borderLeft: '1px solid #979797',
    margin: 0,
    padding: 0,
    borderRadius: 0,
    paddingLeft: 25 * 0.65,
    color: '#363638',
    // width: 542 * 0.65,
    width: '100%',
    height: '2em',
    maxWidth: '100%',
    '&::placeholder': {
      color: '#B3B3B1',
    },
    '&:focus': {
      outline: 'none'
    },
  },
  hasError: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    '&::placeholder': {
      color: theme.palette.error.main,
    },
  },
  fullWidth: {
    width: '100%'
  },
  multiline: {
    resize: 'none',
    overflow: 'hidden',
    minHeight: '2em',
    lineHeight: '1.2em',
    paddingTop: '0.4em',
    paddingBottom: '0.4em',
  },
})

export default
@withStyles(styles)
class OnboardingStepInput extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    onEnterPress: PropTypes.func,
    validation: PropTypes.object,
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
    fullWidth: PropTypes.bool,
    multiline: PropTypes.bool,
    className: PropTypes.any,
    defaultValue: PropTypes.string,
    value: PropTypes.string,
  }

  static defaultProps = {
    onEnterPress: () => {},
    onChange: () => {},
    inputRef: () => {},
    defaultValue: '',
  }

  constructor({ defaultValue, value }) {
    super()
    this.state = { value: value || defaultValue }
  }

  componentDidMount() {
    this.updateHeight()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.state
    if (prevState.value !== value) {
      this.updateHeight()
    }
  }

  updateHeight = () => {
    const { multiline } = this.props
    if (multiline) {
      this.input.style.height = '1px'
      this.input.style.height = `${this.input.scrollHeight}px`
    }
  }

  handleKeyPress = (ev) => {
    const { onEnterPress } = this.props
    if (ev.key === 'Enter') {
      onEnterPress(ev)
    }
  }

  handleChange = (ev) => {
    const { validation, onChange } = this.props
    const { value } = ev.target
    this.setState({ value })
    onChange(ev)
    if (validation && (validation.isInvalid || validation.isValid)) {
      validation.reset()
    }
  }

  inputRef = (input) => {
    const { inputRef } = this.props
    this.input = input
    inputRef(input)
  }

  renderError() {
    const { validation } = this.props
    return validation
      && validation.isInvalid
      && validation.error.message !== 'Validation Error'
      && (
        <Fragment>
          <Spacer small />
          <Typography color="error">
            { validation.error.message }
          </Typography>
        </Fragment>
      )
  }

  render() {
    const { classes, onEnterPress, validation, defaultValue,
      inputRef, fullWidth, className, multiline, ...rest } = this.props

    const { value } = this.state

    const cx = classNames(classes.root, className, {
      [classes.hasError]: validation && validation.isInvalid,
      [classes.fullWidth]: fullWidth,
      [classes.multiline]: multiline,
    })

    const props = {
      ...rest,
      value,
      ref: this.inputRef,
      className: cx,
      onKeyPress: this.handleKeyPress,
      onChange: this.handleChange,
    }

    const component = multiline ? 'textarea' : 'input'
    return (
      <div>
        { createElement(component, props) }
        { this.renderError() }
      </div>
    )
  }
}
